import { defineComponent as _defineComponent } from 'vue'
import { PropType, computed, ref } from "vue";
import QExpandableDataTable from "../../../components/datatables/QExpandableDataTable.vue";
import { MetricValues } from "../api";
import AgentNameCol from "./AgentNameCol.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AoMetricDataTable',
  props: {
  items: { type: Array as PropType<(MetricValues)[]>, default: () => [] },
},
  setup(__props) {

const props = __props



const headers: { value: keyof MetricValues, text: string }[] = [
	{
		text: "Agent Name",
		value: 'AgentName',
	},
	{
		text: 'RTW',
		value: 'OnboardedAgents',
	},
	{
		text: "APV/Agent",
		value: 'MonthlyAPVPerAgent',
	},
	{
		text: "APV/Writer",
		value: "MonthlyAPVPerWriter",
	},
	{
		text: "Apps/Agent",
		value: 'MonthlyAppsPerAgent',
	},
	{
		text: "Apps/Writer",
		value: 'MonthlyAppsPerWriter',
	},
	{
		text: "Writers",
		value: 'Writers',
	},
	{
		text: "RTW to Writer %",
		value: 'WritersPerAgent',
	},
	{
		text: 'RTW to Active Writer %',
		value: 'ActiveWritersPerAgent',
	},
	{
		text: 'RTW to SNA %',
		value: "SNAsPerAgent"
	},
	{
		text: "% of Writers Active",
		value: 'ActiveWritersPerWriter',
	},
	{
		text: 'Writer to SNA %	',
		value: 'SNAsPerWriter'
	},
	{
		text: 'Active Writers',
		value: 'ActiveWriters',
	}
];

const toInt = (v: number) => Number(v).toFixed(0);
const toFixed2 = (v: number) => Number(v).toFixed(2);

const toPercent = (v: number) => `${(Number(v) * 100).toFixed(0)}%`;

return { __sfc: true,props, headers, toInt, toFixed2, toPercent, QExpandableDataTable, AgentNameCol }
}

})